export default "__VITE_ASSET__N2905awl__"